import script from './component-lib.esm3.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm.link.label ? _c('ProfileTitle', {
    attrs: {
      "link": {
        label: _vm.link.label
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.layout === 'stacked' && _vm.itemsToShow.length > 1 ? _c('StackedLayout', {
    attrs: {
      "feed-options": _vm.feedOptions
    },
    on: {
      "open": function ($event) {
        return _vm.$emit('event', _vm.EVENTS.FEED_STACK_EXPANSION);
      },
      "event": _vm.handleEvent
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var attrs = ref.attrs;
        return _vm._l(_vm.itemsToShow, function (item, i) {
          return _c('ProfileLinkWrapper', {
            key: item.id
          }, [_c('FeedBtn', _vm._b({
            attrs: {
              "item": item,
              "showImages": _vm.showImages,
              "embedType": _vm.feedOptions.embed_type
            },
            on: {
              "click": function ($event) {
                return _vm.handleClick(item, $event);
              }
            }
          }, 'FeedBtn', Object.assign({}, _vm.btnProps, {
            highlight: i === 0 ? _vm.highlight : ''
          }, attrs, {
            enableUtmParameters: _vm.enableUtmParameters,
            utmMedium: _vm.utmMedium,
            utmSource: _vm.utmSource
          }), false))], 1);
        });
      }
    }], null, false, 2225686608)
  }) : _vm._l(_vm.itemsToShow, function (item, i) {
    return _c('ProfileLinkWrapper', {
      key: item.id,
      on: {
        "event": _vm.handleEvent
      }
    }, [_c('FeedBtn', _vm._b({
      attrs: {
        "item": item,
        "showImages": _vm.showImages,
        "embedType": _vm.feedOptions.embed_type
      },
      on: {
        "click": function ($event) {
          return _vm.handleClick(item, $event);
        }
      }
    }, 'FeedBtn', Object.assign({}, _vm.btnProps, {
      highlight: i === 0 ? _vm.highlight : '',
      enableUtmParameters: _vm.enableUtmParameters,
      utmMedium: _vm.utmMedium,
      utmSource: _vm.utmSource
    }), false))], 1);
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var ProfileFeed = __vue_component__;
export { ProfileFeed as default };